// https://gist.github.com/SimonJThompson/c9d01f0feeb95b18c7b0

function toRad(v) {
	return v * Math.PI / 180
}

function kmToMiles(km) {
	return (km * 0.62137).toFixed(0)
}

export function haversine(p1, p2, unit = 'mi') {
	const R = 6371 // km
	const x1 = p2.lat - p1.lat
	const dLat = toRad(x1)
	const x2 = p2.lng - p1.lng
	const dLon = toRad(x2)
	const a =
		Math.sin(dLat / 2) * Math.sin(dLat / 2) +
		Math.cos(toRad(p1.lat)) * Math.cos(toRad(p2.lat)) *
		Math.sin(dLon / 2) * Math.sin(dLon / 2)
	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
	const d = R * c

	switch (unit) {
		case 'km':
			return d.toFixed(0)
		case 'mi':
			return kmToMiles(d)
		default:
			return -1
	}
}